import React from 'react';
import SectionHeader from './SectionHeader';

const strengths = [
  'Product-Led Growth',
  'AI Workflows & GTM Automation',
  'SEO & Content Marketing',
  'Paid Media (Search, Social)',
  'Conversion Rate Optimization',
  'Lifecycle Marketing & Email Automation',
  'Data Analytics & Visualization',
  'Growth Team Leadership & Coaching',
  'GTM Strategy for M&A and Product Launches',
];

const technical = [
  'Claude Code / Codex',
  'GA4',
  'SQL',
  'Python',
  'Mixpanel',
  'Tableau',
  'Grafana',
  'Ahrefs',
  'SEMRush',
];

const Tag = ({ children, muted }) => (
  <li
    className={`rounded-full px-3 py-1.5 text-sm font-medium leading-none ${
      muted
        ? 'bg-light-navy/50 text-light-slate'
        : 'bg-gold/10 text-gold ring-1 ring-inset ring-gold/25'
    }`}
  >
    {children}
  </li>
);

const Skills = () => {
  return (
    <section
      id="skills"
      className="content-section pt-4 pb-6 sticky-section"
      aria-label="Strengths and skills"
    >
      <SectionHeader id="skills" title="Strengths & Skills" />

      <div>
        <div className="rounded-lg border border-light-navy bg-navy p-5">
          <ul className="flex flex-wrap gap-2">
            {strengths.map((skill) => (
              <Tag key={skill}>{skill}</Tag>
            ))}
          </ul>

          <h3 className="mt-6 text-xs font-bold uppercase tracking-widest text-slate">
            Technical
          </h3>
          <ul className="mt-3 flex flex-wrap gap-2">
            {technical.map((tool) => (
              <Tag key={tool} muted>
                {tool}
              </Tag>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;
